(() => {
  const images = [...document.querySelectorAll('#EvSale img[data-sale-src]')];
  if (!images.length) return;
  const load = image => {
    if (image.dataset.saleSrcset) image.srcset = image.dataset.saleSrcset;
    image.src = image.dataset.saleSrc;
    delete image.dataset.saleSrc;
    delete image.dataset.saleSrcset;
  };
  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    window.removeEventListener('scroll', start);
    if (!('IntersectionObserver' in window)) return images.forEach(load);
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        load(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '800px 0px' });
    images.forEach(image => observer.observe(image));
  };
  const hero = document.querySelector('.sale-hero-visual img');
  if (!hero || hero.complete) start();
  else {
    hero.addEventListener('load', start, { once: true });
    hero.addEventListener('error', start, { once: true });
    window.addEventListener('scroll', start, { once: true, passive: true });
    setTimeout(start, 5000);
  }
})();
